import FormEmailRecipientsComponent from 'webapp/components/form/email-recipients';

export default class FormEmailAdminRecipientsComponent extends FormEmailRecipientsComponent {
	override get userDataForList() {
		return this.mmUsersService.activatedAdminsWithoutAgencyAdminsList;
	}
}
